import { SyntheticEvent, useState } from "react";
import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import {
  ClinicianDetailsTab,
  ClinicianPatientsTab,
  TabPanel,
} from "../components";
import { useClinicianContext } from "../components/ClinicianContext";

const a11yProps = (index: number) => {
  return {
    id: `profile-tab-${index}`,
    "aria-controls": `profile-tabpanel-${index}`,
  };
};

const ClinicianProfile = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const [clinician] = useClinicianContext();

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setTabIdx(newValue);
  };

  return (
    <Stack spacing={2}>
      <Typography variant="h4">Clinician Profile</Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabIdx} onChange={handleChange} aria-label="profile tabs">
          <Tab label="Details" {...a11yProps(0)} />
          <Tab label="Patients" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={tabIdx} index={0}>
        <ClinicianDetailsTab
          clinicianId={clinician.clinicianId!}
          clinicianDetails={clinician}
        />
      </TabPanel>
      <TabPanel value={tabIdx} index={1}>
        <ClinicianPatientsTab clinicianId={clinician.clinicianId} />
      </TabPanel>
    </Stack>
  );
};

export default ClinicianProfile;
